"use client";

import { useCryptoComCta } from "./useCryptoComCta";
import { ExchangeIcon } from "@/components/icons";

const KEYFRAMES = `
@keyframes cdc-breathe {
  0%   { box-shadow: 0 0 6px 1px rgba(17,153,250,0.04); }
  12%  { box-shadow: 0 0 10px 3px rgba(17,153,250,0.10); }
  25%  { box-shadow: 0 0 4px 1px rgba(17,153,250,0.02); }
  38%  { box-shadow: 0 0 8px 2px rgba(17,153,250,0.07); }
  52%  { box-shadow: 0 0 12px 3px rgba(17,153,250,0.12); }
  65%  { box-shadow: 0 0 5px 1px rgba(17,153,250,0.03); }
  78%  { box-shadow: 0 0 9px 2px rgba(17,153,250,0.08); }
  88%  { box-shadow: 0 0 6px 2px rgba(17,153,250,0.05); }
  100% { box-shadow: 0 0 6px 1px rgba(17,153,250,0.04); }
}
`;

export const CryptoComCtaButton = () => {
  const { isEnabled, rewardAmount, handleClick } = useCryptoComCta();

  if (!isEnabled) return null;

  return (
    <>
      <style>{KEYFRAMES}</style>
      <button
        onClick={() => handleClick("header")}
        className="group relative flex h-9 items-center gap-2 rounded-lg px-3 btn-medium whitespace-nowrap cursor-pointer transition-all duration-300 border border-[#1199FA]/15 hover:border-[#1199FA]/30"
        style={{
          background: "rgba(11, 61, 145, 0.25)",
          animation: "cdc-breathe 10s ease-in-out infinite",
        }}
      >
        {/* Inner subtle gradient */}
        <div
          className="pointer-events-none absolute inset-0 rounded-lg opacity-30"
          style={{
            background: "radial-gradient(ellipse at 50% 0%, rgba(17,153,250,0.15) 0%, transparent 70%)",
          }}
        />

        {/* Hover overlay */}
        <div className="pointer-events-none absolute inset-0 rounded-lg bg-[#1199FA]/0 transition-colors duration-500 group-hover:bg-[#1199FA]/[0.08]" />

        {/* Content */}
        <span className="relative z-10 flex items-center gap-2">
          <ExchangeIcon exchange="cryptocom" size="sm" />
          <span className="text-white/85 transition-colors duration-300 group-hover:text-white">
            {rewardAmount ? (
              <>
                Sign Up on Crypto.com & Win <span className="font-bold text-[#1199FA]">${rewardAmount}</span>
              </>
            ) : (
              "Sign Up on Crypto.com"
            )}
          </span>
        </span>
      </button>
    </>
  );
};
